import * as React from 'react'
import { any, async, fromJSX, IOWidget, Updater } from 'widgets-for-react'
import { ContactLayout } from './contactLayout'
import { ContactState, contactStateUpdaters } from './contactState'

export const contactWidget: IOWidget<ContactState, Updater<ContactState>> = (
  contactState
) =>
  any([
    async(contactState.submitState).map(contactStateUpdaters.updateSubmitState),
    fromJSX((setState) => (
      <ContactLayout
        submitStatus={
          contactState.submitState.kind === 'unloaded'
            ? 'not submitted'
            : contactState.submitState.kind === 'loading'
            ? 'submitting'
            : contactState.submitState.kind === 'loaded'
            ? 'success'
            : 'error'
        }
        onSubmit={() => setState(contactStateUpdaters.submit)}
        formInput={contactState.formInput}
        onChange={{
          email: (newValue) =>
            setState(contactStateUpdaters.updateFormInput('email', newValue)),
          name: (newValue) =>
            setState(contactStateUpdaters.updateFormInput('name', newValue)),
          surname: (newValue) =>
            setState(contactStateUpdaters.updateFormInput('surname', newValue)),
          subject: (newValue) =>
            setState(contactStateUpdaters.updateFormInput('subject', newValue)),
          message: (newValue) =>
            setState(contactStateUpdaters.updateFormInput('message', newValue)),
        }}
        showFormInputValidation={contactState.showFormInputValidation}
        onBlur={{
          email: () =>
            setState(contactStateUpdaters.showFormInputValition('email')),
          name: () =>
            setState(contactStateUpdaters.showFormInputValition('name')),
          surname: () =>
            setState(contactStateUpdaters.showFormInputValition('surname')),
          subject: () =>
            setState(contactStateUpdaters.showFormInputValition('subject')),
          message: () =>
            setState(contactStateUpdaters.showFormInputValition('message')),
        }}
        isValid={{
          email:
            !!contactState.formInput.email &&
            contactState.formInput.email.includes('@'),
          name: !!contactState.formInput.name,
          surname: !!contactState.formInput.surname,
          subject: !!contactState.formInput.subject,
          message: !!contactState.formInput.message,
        }}
      />
    )),
  ])
